import React, {useState} from 'react';
import { Form, Input, Button, message } from 'antd';
import axios from 'axios';
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};



// const exportar = () => {
    function Exportar() {
        const [loading, setLoading] = useState(false)

  const onFinish = (values) => {
    // console.log('Success:', values);
    // console.log("values " + JSON.stringify(values))
    const baseUrl = "https://a3l.com.ar/Cotizador/Backend/exportExcel"; //http://localhost:3900/jubilacion/exportExcel
          
    //POST - INSERTAR
    const peticionPost = async() => {    
        await axios.post(baseUrl,values)
        .then(response=>{
            console.log("respuesta: " + JSON.stringify(response));
            console.log("respuesta.data.status " + response.data.status)
            if(response.data.status === 'error'){
                message.error("UPS! HA OCURRIDO UN ERROR! " + response.data.message );
                console.log("acà vamos a llamar a la grabaciòn de un log...");
                setLoading(false);
            }
            else{
                
                // const peticionGet = async() => {
                //     // const baseUrl = "http://localhost:3900/jubilacion/downloadExcel/" + response.data.excel; 
                //     const baseUrl2 = "http://localhost:3900/jubilacion/downloadExcel/"
                //     await axios.get(baseUrl2)
                //     .then(response2=>{
                //         // message.success("111 Las consultas se exportaron exitosamente " + JSON.stringify(response2)) 
                //         message.success("111 Las consultas se exportaron exitosamente ") 
                //     }).catch(error=>{
                //         message.error("UPS! HA OCURRIDO UN ERROR AL BAJAR EL EXCEL " + error.message );
                //     })
                // }
                // peticionGet();
                setLoading(false);
                window.location.href = "https://a3l.com.ar/Cotizador/Backend/downloadExcel/" + response.data.excel;//http://localhost:3900/jubilacion/downloadExcel/
            }

        }).catch(error=>{
            // console.log("error " + error);
            console.log("error " + JSON.stringify(error));
            setLoading(false);            
        })                    
      };
      
      peticionPost();
      setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Form
      {...layout}
      name="basic"
      initialValues={{ remember: false }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >


      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: 'Por favor ingrese contraseña' }]}
      >
        <Input.Password />
      </Form.Item>


      <Form.Item {...tailLayout}>
      <Button 
                              name="botoncotizar" 
                              size="large"
                              type="primary"                   
                              htmlType="submit"
                              loading={loading}
                              >  
          Exportar
        </Button>
      </Form.Item>
    </Form>
  );
};

// ReactDOM.render(<Exportar />, mountNode);

export default Exportar